import { PoweringCaseStudyCard } from "./PoweringCaseStudyCard";

export const PoweringCaseStudiesList = ({ poweringCaseStudies, loading }) => {
  return (
    <section className="webinars_list">
      <section className="webinars_list-main">
        <section className="section-layout">
          <section className="webinars_list-list">
            {poweringCaseStudies.map((caseStudy, caseStudyIndex) => {
              {
                return (
                  <PoweringCaseStudyCard
                    caseStudy={caseStudy}
                    key={`${caseStudyIndex}-${caseStudy.title}`}
                  />
                );
              }
            })}
          </section>
          {loading && <span className="webinars_list-spinner" />}
        </section>
      </section>
    </section>
  );
};
